import {reactive} from 'vue'

export default (search) => {
  const pagination = reactive({
    page: 1,
    total: 0,
    pageSize: 50
  })

  const _search = async () => {
    if(search){
      const newPagination = await search(pagination)
      pagination.page = +newPagination.page
      pagination.total = +newPagination.total
      pagination.pageSize = +newPagination.pageSize
    }
  }

  const next = () => {
    pagination.page = pagination.page + 1
    _search()
  }

  const prev = () => {
    pagination.page = pagination.page - 1
    _search()
  }

  const jumpTo = page => {
    pagination.page = page
    _search()
  }

  return {
    pagination,
    next,
    prev,
    jumpTo
  }
}
